import React, { useEffect, useState } from 'react'
import dashboardActions from '../../redux/dashboard/actions';
import { useDispatch, useSelector } from "react-redux";
import { formatDigits } from '../../helpers/commonFunction';

const { getActivationCount } = dashboardActions;


const ActivationCount = () => {
    const dispatch = useDispatch();
    const { activationCountData, activationCountLoading } = useSelector((state) => state.dashboard);
    useEffect(() => {
        dispatch(getActivationCount(1))
    }, [])

    const activationData = activationCountData && activationCountData.length > 0 ? activationCountData.map((item, ind) => ({
        ...item,
        ActivationData: JSON.parse(item.ActivationData)
    })) : [];

    return (
        <div>
            <div>
                <div className="iq-card-header">
                    <div className="iq-header-title">
                        <h4 className="card-title font-weight-bold" style={{ fontSize: "18px" }}>Transaction Count</h4>
                    </div>
                </div>
                <div style={{ position: 'absolute', right: '35px', top: '12px' }}>
                    <i className="ri-refresh-line" onClick={() => dispatch(getActivationCount(1))} style={{ fontSize: '1.2rem', cursor: 'pointer' }}></i>
                </div>
            </div>
            {activationCountLoading ? <div className="dashboard-activation-loader-activation">
                <span className="spinner-border" role="status"></span>
            </div> : <div className='iq-card-body  pt-1'>
                {activationData && activationData.length > 0 && activationData.map((data, index) => (
                    <div className='activation_count_parent'>

                        <h2 className='font-weight-bold mb-2' style={{ fontSize: "18px", color: "#1D1D1F" }}>{data.AggregatorName}</h2>
                        <div className='table-responsive'>
                            <table style={{ width: '100%' }}>
                                <tr>

                                    <th>Network</th>
                                    <th>Today</th>
                                    <th>MTD</th>
                                    <th>Last Month</th>
                                </tr>

                                <tr>
                                    <td>{data.ActivationData && data.ActivationData.length > 0 && data.ActivationData.map((item, ind) => (
                                        <div>
                                            {item.NetworkName}
                                        </div>
                                    ))}</td>
                                    <td>{data.ActivationData && data.ActivationData.length > 0 && data.ActivationData.map((item, ind) => (
                                        <div>
                                            {formatDigits(item.TodayCount)}
                                        </div>
                                    ))}</td>
                                    <td>{data.ActivationData && data.ActivationData.length > 0 && data.ActivationData.map((item, ind) => (
                                        <div>
                                            {formatDigits(item.MonthTotal)}
                                        </div>
                                    ))}</td>
                                    <td>{data.ActivationData && data.ActivationData.length > 0 && data.ActivationData.map((item, ind) => (
                                        <div>
                                            {formatDigits(item.LastMonthTotal)}
                                        </div>
                                    ))}</td>
                                </tr>

                            </table>
                        </div>
                    </div>

                ))
                }



            </div>}

        </div>
    )
}

export default ActivationCount
